import React, { useEffect, useState } from "react";
import useCheckAuth from "../hooks/useCheckAuth";
import { BaseUrl } from "../api";
import { courseType } from "../@types/course";
import { toast } from "react-toastify";
import { Button } from "@nextui-org/react";
import useCsrfToken from "../hooks/useCsrfToken";

const Home = () => {
  const { user } = useCheckAuth();
  const { csrfToken } = useCsrfToken();
  const [courseDeleted, setCourseDeleted] = useState(false);
  const [studentCourses, setStudentCourses] = useState<courseType[] | null>(
    null
  );

  const handleUnRegister = async (courseCode: string) => {
    try {
      const response = await fetch(`${BaseUrl}/courses/${courseCode}/unreg`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log(data);
      setCourseDeleted(!courseDeleted);
      toast.success("Course unregistered successfully");
    } catch (error) {
      console.log(error);
      toast.error("Failed to unregister course");
    }
  };

  useEffect(() => {
    const getStudentCourses = async () => {
      try {
        const response = await fetch(`${BaseUrl}/courses/std/`, {
          credentials: "include",
        });

        if (!response.ok) {
          console.log("error");
        }

        const data = await response.json();
        console.log(data);
        setStudentCourses(data.courses);
        localStorage.setItem("StudentCourses", JSON.stringify(data.courses));
      } catch (error) {
        toast.error("Failed to fetch courses");
      }
    };

    getStudentCourses();
  }, [courseDeleted]);

  return (
    <div className="flex items-center justify-center flex-col">
      <div className="mt-10">
        <span className="text-xl">Student: {user?.username}</span>
        <h1 className="text-3xl font-semibold my-4 dark:text-white">
          Your Registered Courses
        </h1>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg my-6">
        <table className="w-full text-lg text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-md text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                Code
              </th>
              <th scope="col" className="px-6 py-3">
                Instructor
              </th>
              <th scope="col" className="px-6 py-3">
                Name
              </th>
              <th scope="col" className="px-6 py-3">
                Capacity
              </th>
              <th scope="col" className="px-6 py-3">
                Unregister
              </th>
            </tr>
          </thead>
          <tbody>
            {studentCourses?.map((course) => (
              <tr
                key={course.id}
                className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
              >
                <td className="px-6 py-4">{course.code}</td>
                <td className="px-6 py-4">{course.instructor}</td>
                <td className="px-6 py-4">{course.name}</td>
                <td className="px-6 py-4">{course.capacity}</td>
                <td className="px-6 py-4">
                  <Button
                    onClick={() => handleUnRegister(course.code)}
                    variant="flat"
                    color="danger"
                  >
                    Unregister
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg my-6">
        <table className="w-full text-lg text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-md text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                Schedule ID
              </th>
              <th scope="col" className="px-6 py-3">
                Course Name
              </th>
              <th scope="col" className="px-6 py-3">
                Days
              </th>
              <th scope="col" className="px-6 py-3">
                Start Time
              </th>
              <th scope="col" className="px-6 py-3">
                End Time
              </th>
              <th scope="col" className="px-6 py-3">
                Room No
              </th>
            </tr>
          </thead>
          <tbody>
            {studentCourses?.map((course) => (
              <tr
                key={course?.schedule_id?.schedule_id}
                className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
              >
                <td className="px-6 py-4">
                  {course?.schedule_id?.schedule_id}
                </td>
                <td className="px-6 py-4">{course?.name}</td>
                <td className="px-6 py-4">{course?.schedule_id?.days}</td>
                <td className="px-6 py-4">{course?.schedule_id?.start_time}</td>
                <td className="px-6 py-4">{course?.schedule_id?.end_time}</td>
                <td className="px-6 py-4">{course?.schedule_id?.room_no}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Home;
